import React from 'react';
export function HowToUse() {
  return <section className="bg-orange-50 py-8 sm:py-12 md:py-16" data-id="element-244">
      <div className="max-w-4xl mx-auto px-4" data-id="element-245">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8 md:mb-12 text-center" data-id="element-246">
          Cómo Usar el Sistema
        </h2>
        <div className="space-y-4 sm:space-y-6" data-id="element-247">
          <div className="flex gap-3 sm:gap-4" data-id="element-248">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-249">
              1
            </div>
            <div data-id="element-250">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-251">
                Domingo: Batch Cooking Express (60 min)
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-252">
                Dedica una hora el domingo para preparar las bases. Con nuestra
                guía paso a paso, tendrás arroz cocido, pollo listo, verduras
                cortadas y todo organizado para la semana.
              </p>
            </div>
          </div>
          <div className="flex gap-3 sm:gap-4" data-id="element-253">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-254">
              2
            </div>
            <div data-id="element-255">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-256">
                Lunes a Viernes: Sigue el Menú Semanal
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-257">
                Cada día ya tiene su receta asignada. Solo abre el plan, saca
                los ingredientes (que ya preparaste el domingo) y cocina en 15
                minutos exactos.
              </p>
            </div>
          </div>
          <div className="flex gap-3 sm:gap-4" data-id="element-258">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-259">
              3
            </div>
            <div data-id="element-260">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-261">
                Usa los Swaps Latinos cuando lo necesites
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-262">
                ¿No encuentras un ingrediente? Usa nuestra guía de sustituciones
                adaptadas a cada país de Latinoamérica. Siempre hay una
                alternativa local.
              </p>
            </div>
          </div>
          <div className="flex gap-3 sm:gap-4" data-id="element-263">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-264">
              4
            </div>
            <div data-id="element-265">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-266">
                Disfruta la calma y la sonrisa de tu familia
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-267">
                Sin estrés. Sin improvisación. Sin protestas. Solo comida rica,
                hecha en minutos, y tiempo de calidad con los tuyos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}